import { i18n } from '@shared/i18n';
import { GenericModel } from '@shared/model/generic-model';

import getSharedEnumeratorField from '@shared/fields/helpers/getSharedEnumeratorField';

import StringField from '@shared/fields/string-field';
import EnumeratorField from '@shared/fields/enumerator-field';
import BooleanField from '@shared/fields/boolean-field';
import StringArrayField from '@shared/fields/string-array-field';

function label(name) {
  return i18n(`entities.clubCategory.fields.${name}`);
}

const fields = {
  gender: new EnumeratorField('gender', label('gender'), getSharedEnumeratorField('genderBinary'), { required: true }),
  format: new EnumeratorField('format', label('format'), getSharedEnumeratorField('soccerFormat'), { required: true }),
  ageCategory: new StringField('ageCategory', label('ageCategory'), { required: true }),
  minimumPlayersCommitment: new BooleanField('minimumPlayersCommitment', label('minimumPlayersCommitment'), { mandatoryTrue: true }),
  multipleTeams: new BooleanField('multipleTeams', label('multipleTeams'), { required: true }),
  teams: new StringArrayField('teams', label('teams'), { required: true }),
};

export class ClubCategoryModel extends GenericModel {
  static get fields() {
    return fields;
  }
}
